import { Card, CardContent, FormControl,Checkbox, Typography, Grid } from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import React from 'react';
import GridItem from 'components/Grid/GridItem.jsx';
import {CompanyLevels} from './CompanyLevels.jsx';
import {planDetails} from './planDetails.jsx'
import medihelp from 'assets/img/logo/medihelp.jpg';
import {gapDetails} from './GapDetails.jsx'
import { Field } from 'redux-form';


const CustomFieldFullWidth = props => (
	<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

class CompanySelection extends React.Component {
	state = {
		availTargets: [],
		gapTargets: []
	};

	

	componentDidMount() {
		this.props.scrollMeBar();
	}

	handleCheck = id => {
		
		if (this.props.selectedTargets.find(t => t === id))
		{
			this.props.checkSelectedTarget(id, false);
		} else 
		{
			if(this.props.selectedTargets.length < 4)
				this.props.checkSelectedTarget(id, true);
		}
		this.forceUpdate();
	};

	handleCheckGap = id => {
		//console.log("HELLO ==" + id)
		if (this.props.selectedTargetsGap.find(t => t === id)) {
			this.props.checkSelectedTargetGap(id, false);
		} else {
			if(this.props.selectedTargetsGap.length < 1)
				this.props.checkSelectedTargetGap(id, true);
		}
		this.forceUpdate();
	};

	handleCheckLoyalty = id => {
		if (this.props.selectedTargetsLoyalty.find(t => t === id)) {
			this.props.checkSelectedTargetLoyalty(id, false);
		} else {
			this.props.checkSelectedTargetLoyalty(id, true);
		}
		this.forceUpdate();
	};

	checkAll = () => {
		if (
			this.props.selectedTargets.length !==
			this.props.AvailTargetsForBroker.length
		) {
			this.props.toggleAllTargets(this.props.AvailTargetsForBroker, true);
		} else {
			this.props.toggleAllTargets(this.props.AvailTargetsForBroker, false);
		}
		this.forceUpdate();
	};

	checkAllGap = () => {
		if (
			this.props.selectedTargetsGap.length !==
			this.props.AvailTargetsForBrokerGap.length
		) {
			this.props.toggleAllTargetsGap(this.props.AvailTargetsForBrokerGap, true);
		} else {
			this.props.toggleAllTargetsGap(this.props.AvailTargetsForBrokerGap, false);
		}
		this.forceUpdate();
	};

	checkAllLoyalty = () => {
		if (
			this.props.selectedTargetsLoyalty.length !==
			this.props.AvailTargetsForBrokerLoyalty.length
		) {
			this.props.toggleAllTargetsLoyalty(this.props.AvailTargetsForBrokerLoyalty, true);
		} else {
			this.props.toggleAllTargetsLoyalty(this.props.AvailTargetsForBrokerLoyalty, false);
		}
		this.forceUpdate();
	};

	populateCompany = (targets) =>
	{
		var current = "";
		var result = [];
		var trg = targets
		//trg.sort(function(a, b){ return a.planType.localeCompare(b.planType)});
		//console.log("??????????" + JSON.stringify( targets))
		//console.log("??????????" + JSON.stringify( trg))

		targets.forEach(target =>
		{
			if(current == target.company)
			{
				
				
				if(!result[target.company][target.planType])
					result[target.company][target.planType] = [];
				
				result[target.company][target.planType].push(target);
				
				//result[target.company].sort(function(a, b){ return a.planType.localeCompare(b.planType)});
				
			}
			else
			{
				current = target.company;
				result[target.company] = [];
				result[target.company][target.planType] = [];
				result[target.company][target.planType].push(target);

				
			}
		})
		//Sorting each companies plans according to keys
		Object.keys(result).forEach(e =>
			{
				
				 result[e] = Object.keys(result[e]).sort().reduce(function (acc, key) 
						{ 
        					acc[key] = result[e][key];
        					return acc;
    					}, {});
				
			})
			
			return result;
	}

	ageCheck = (ageC) =>
	{
		var person = ageC.split(",")[0];
		var opperator = ageC.split(",")[1];
		var age = ageC.split(",")[2];

		var eldest = this.props.state.clientAge;
		this.props.state.dependentsAdult.forEach(e =>
		{
			if(new Date().getFullYear() - new Date(e.dob).getFullYear()  > eldest)
				eldest = new Date().getFullYear() - new Date(e.dob).getFullYear();
		})

		if(person == "p")
		{
			if(opperator == ">")
			{
				if(this.props.state.clientAge > age)
					return true;
				else
					return false;
			}
			else
			{
				if(this.props.state.clientAge < age)
				{
					if(age < 64)
					{
						if(this.props.state.clientAge > 44)
							return true;
						else
							return false;
					}
					else
					{
						return true;
					}
						
				}
				else
					return false;
			}
		}
		else
		{
			if(opperator == ">")
			{
				if(eldest > age)
					return true;
				else
					return false;
			}
			else
			{
				if(eldest < age)
				{
					if(age < 64)
					{
						if(eldest > 44)
							return true;
						else
							return false;
					}
					else
						return true;
						
				}
				else
					return false;
			}
		}
	}

	populateGap = (targets) =>
	{
		var current = "";
		var result = [];

		targets.forEach(target =>
		{
			if(current == target.company)
			{
				
				result[target.company].push(target);
			}
			else
			{
				current = target.company;
				result[target.company] = [];
				result[target.company].push(target);
			}
		})

			return result;
	}

	incomeCondition = (plan) =>
	{
		var income = parseFloat(this.props.state.income);
		var planIncome = plan.familyIncome;
		if(planIncome == "" || planIncome == "N/A")
			return true;
		
		var planIncomeHigh = 0;
		var planIncomeLow = 0;
		var opperator = "";

		planIncome = planIncome.replace(/R/g, "");
		planIncome = planIncome.replace(/ /g, "");

		if(planIncome.includes(">"))
		{
			opperator = ">";
			planIncome = planIncome.replace(/>/g, "");
		}

		if(planIncome.includes("<"))
		{
			opperator = "<";
			planIncome = planIncome.replace(/</g, "");
		}

		if(planIncome.includes("+"))
		{
			opperator = ">";
			planIncome = planIncome.replace("+", "");
		}

		planIncome = planIncome.split("-")

		if(planIncome.length > 1)
		{
			planIncomeHigh = planIncome[1];
			planIncomeLow = planIncome[0];
		}
		else
		{
			planIncomeLow = planIncome[0];
		}

		

		if(opperator != "")
		{
			if(income > planIncomeLow)
			{
				
				return true;
			}
				
		}
		else
		if(income > planIncomeLow && income < planIncomeHigh)
		{
			
			return true;
		}
			
		
		return false;


	}


	render() {
		let targets = this.props.AvailTargetsForBroker;
		let targetsGap = gapDetails;
		let targetsLoyalty = this.props.AvailTargetsForBrokerLoyalty;
		const allSelected = this.props.selectedTargets.length === targets.length;
		const allSelectedGap = this.props.selectedTargetsGap.length === targetsGap.length;
		const allSelectedLoyalty = this.props.selectedTargetsLoyalty.length === targetsLoyalty.length;


		let planType= this.props.planType;
		let coverLevel= this.props.coverLevel;
		let hospitalLevel= this.props.hospitalLevel;
		let chronicProvider= this.props.chronicProvider;
		let serviceProvider= this.props.serviceProvider;
		

		var coverOptions = [];
		var targetsToRender = [];
		var targetsToRenderGap = [];
		var targetsOptionsGap = [];
		
		
		targets = [];

		var currentCompany = "";
		planDetails.forEach(element => 
		{
			//console.log(element)
			//console.log(coverLevel," ", hospitalLevel, " ", chronicProvider, " ", serviceProvider)
			if(planType == element.planType.toLocaleLowerCase() || planType == "all")
				if(coverLevel == element.coverLevel.toLocaleLowerCase() || coverLevel == "all")
					if(hospitalLevel == element.hospital.toLocaleLowerCase() || hospitalLevel == "all")
						if(chronicProvider == element.chronic.toLocaleLowerCase() || chronicProvider == "all")
							if(serviceProvider == element.serviceType.toLocaleLowerCase() || serviceProvider == "all")
						{
							
							//console.log(":::::::::::" + this.props.state.income)
							if(this.incomeCondition(element))
							{
								element.id = element.name
								targets.push(element);
							}
							
							
						}
		});
		//console.log("->"+JSON.stringify(targets))
		//var targets2 = targets.sort(function(a, b){ return a.planType.localeCompare(b.planType)});
		//console.log("--->"+JSON.stringify(targets2))
		targets = this.populateCompany(targets);
		

		targetsGap.forEach(e =>
		{
			
			if(this.ageCheck(e.age))
			{
				if(this.props.state.coPay == 1 && e.coPay == "Gap + co")
				{
					if(this.props.state.gapLevel == 1)
					{
						if(e.level <= 300)
						{
							targetsOptionsGap.push(e)
						}
						
						
					}
					else
					if(this.props.state.gapLevel == 2)
					{
						
						if(e.level <= 500 && e.level > 300)
						{
							targetsOptionsGap.push(e)
						}
						
					}
					else
					if(this.props.state.gapLevel == 3)
					{
						
						if(e.level > 500)
						{
							targetsOptionsGap.push(e)
						}
					}
				}
				else
				{
					if(this.props.state.coPay == 0 && e.coPay == "Gap")
					{
						if(this.props.state.gapLevel == 1)
						{
							if(e.level <= 300)
							{
								targetsOptionsGap.push(e)
							}
						}
						else
						if(this.props.state.gapLevel == 2)
						{
							
							if(e.level <= 500 && e.level > 300)
							{
								targetsOptionsGap.push(e)
							}
						}
						else
						if(this.props.state.gapLevel == 3)
						{
							if(e.level > 500)
							{
								targetsOptionsGap.push(e)
							}
						}
					}
				}
				
			}
		})

		

var tempTargets = [];

	Object.keys(targets).forEach(element =>
		{
			tempTargets = [];
			//console.log("----)"+Object.keys(targets[element])[0])
			const imgSrc = require(`assets/img/logo/${targets[element][Object.keys(targets[element])[0]][0].logo}`);
			
			targetsToRender.push(
				(
					<GridItem xs={12} sm={12} md={2} style={{ marginBottom: '25px' }}>
						<img
							src={imgSrc}
							alt={targets[element][Object.keys(targets[element])[0]][0].name}
							className="targetAffiliationLogoMedical"
							style={{ marginLeft: '20px'}}
						/>
						{
							
							Object.keys(targets[element]).forEach(el =>
								{
									//console.log(">>>>>>>>>>>" + el)
								tempTargets.push((<h6>{targets[element][el][0].planType}</h6>))
									targets[element][el].forEach(e =>
										{
											const selected = this.props.selectedTargets.find(
												s => s === e.id
											)
												? true
												: false;
											tempTargets.push((
												<div
													key={e.id}
													className={'checkboxContainerMedical'}
													style={selected ? { backgroundColor: '#f5f5f5'} : {}}
													onClick={() => this.handleCheck(e.name)}
												>
													<Checkbox checked={selected} />
													<Typography
														style={{ marginTop: 'auto', marginBottom: "auto"}}
														>{e.name}</Typography>
												</div>
											))
										})
								})
							
							
						}
						{tempTargets}
						
					</GridItem>
				)
			)
		})





		targetsOptionsGap = this.populateGap(targetsOptionsGap)

		Object.keys(targetsOptionsGap).forEach(element =>
			{
				tempTargets = [];
				//console.log(element)
				const imgSrc = require(`assets/img/logo/${targetsOptionsGap[element][0].logo}`);
				targetsToRenderGap.push(
					(
						<GridItem xs={12} sm={12} md={2} style={{ marginBottom: '25px' }}>
							<img
								src={imgSrc}
								alt={targetsOptionsGap[element][0].company}
								className="targetAffiliationLogoMedical"
								style={{ marginLeft: '20px'}}
							/>
							{
								
								targetsOptionsGap[element].forEach(e =>
								{
									const selected = this.props.selectedTargetsGap.find(
										s => s === e.plan
									)
										? true
										: false;
									tempTargets.push((
										<div
											key={e.plan}
											className={'checkboxContainerMedical'}
											style={selected ? { backgroundColor: '#f5f5f5'} : {}}
											onClick={() => this.handleCheckGap(e.plan)}
										>
											<Checkbox checked={selected} />
											<Typography
												style={{ marginTop: 'auto', marginBottom: "auto"}}
												>{e.plan}</Typography>
										</div>
									))
								})
							}
							{tempTargets}
							
						</GridItem>
					)
				)
			})






		
		//console.log(targets)
		//console.log(targetsToRender)
		return (
			<div className="contentWithStepper">
				<Card className={this.classes}>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="Plan Selection"
						/>
						<Grid container>
						<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
							
						{targetsToRender.length > 0 ? (
							<div
								style={{
									display: 'block',
									width: '100%',
									marginTop: '15px'
								}}
							>
								<Grid container>
								{targetsToRender}
								</Grid>
							
								
								
							</div>
						) : (
							<Typography style={{ marginTop: '25px' }}>
								No available plans for your specific options.
							</Typography>
						)}
</GridItem>

						</Grid>
						
					</CardContent>
				</Card>

				{
					this.props.state.gapCover == 1 &&
					<Card className={this.classes}>
					<CardContent>
						<CustomCardHeading
							headline="Gap Cover Selection"
						/>
						<Grid container>
						<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
							
						{targetsToRenderGap.length > 0 ? (
							<div
								style={{
									display: 'block',
									width: '100%',
									marginTop: '15px'
								}}
							>
								<Grid container>
								{targetsToRenderGap}
								</Grid>
							
								
								
							</div>
						) : (
							<Typography style={{ marginTop: '25px' }}>
								No available plans for your specific options.
							</Typography>
						)}
</GridItem>

						</Grid>
						
					</CardContent>
				</Card>
				}
			</div>
		);
	}
}

export default CompanySelection;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/CompanySelection.jsx